import React, {FC} from "react";
import {Card, Col, Form, Row} from "react-bootstrap";
import {Field, useFormikContext} from "formik";
import {FormikRowInput} from "@components/panel/formik";
import {ItemInput} from "@components/consumer/helpers";
import {RefRewardType} from "@interfaces/consumer/refs";
import {RefRewardFormValues} from "./refRewardBaseInfoBlock";

const RefRewardContentBlock: FC = () => {
    const {values, setFieldValue, errors} = useFormikContext<RefRewardFormValues>();

    const getTitle = () => {
        switch (values.type) {
            case RefRewardType.Balance:
                return "Сумма награды";
            case RefRewardType.Item:
                return "Предмет";
            case RefRewardType.Percent:
                return "Процент от доната";
            default:
                return "Награда";
        }
    };

    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">{getTitle()}</Card.Header>
            <Card.Body>
                {values.type === RefRewardType.Balance && (
                    <Field
                        label="Сумма"
                        name="balance"
                        type="number"
                        component={FormikRowInput}
                    />
                )}

                {values.type === RefRewardType.Item && (
                    <>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Предмет</Form.Label>
                            <Col sm={9}>
                                <ItemInput
                                    name="itemId"
                                    value={values.itemId || ''}
                                    setFieldValue={setFieldValue}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors.itemId}
                                </Form.Control.Feedback>
                            </Col>
                        </Form.Group>

                        <Field
                            label="Количество"
                            name="count"
                            type="number"
                            component={FormikRowInput}
                        />
                    </>
                )}

                {values.type === RefRewardType.Percent && (
                    <>
                        <Field
                            label="Процент"
                            name="percent"
                            type="number"
                            component={FormikRowInput}
                        />
                        <Field
                            label="Минимальная сумма"
                            name="minSum"
                            type="number"
                            component={FormikRowInput}
                        />
                        <Field
                            label="Максимальная сумма"
                            name="maxSum"
                            type="number"
                            component={FormikRowInput}
                        />
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default RefRewardContentBlock;
